import React from 'react';
import { useTranslation } from 'react-i18next';
import { fmtNum } from '../../lib/formatHelpers';

/**
 * V2 CockpitBar — Strip horizontal résumé style "mission control".
 * Affiche : opsLive indicator · creators total / active · critical alerts · version.
 *
 * NoiRock adaptation : remplacement des couleurs Black-Ads hardcodées par des
 * variables sémantiques (text-success, text-error). Police monospace conservée.
 */
export default function CockpitBar({ totalCreators = 0, activeCreators = 0, critical = 0, version }) {
  const { t } = useTranslation();
  return (
    <div className="flex justify-between items-center gap-2 px-3 py-2 border border-border rounded-lg bg-card text-[10.5px] text-muted-foreground/80 font-data overflow-x-auto">
      <span className="flex items-center gap-1.5 text-success shrink-0">
        <span className="inline-block w-1.5 h-1.5 rounded-full bg-success animate-pulse" />
        {t('managerV2.cockpit.opsLive', 'OPS LIVE')}
      </span>
      <span className="shrink-0">
        {t('managerV2.cockpit.team', 'TEAM')}{' '}
        <span className="text-foreground font-semibold">{fmtNum(activeCreators)}</span>
        <span className="text-muted-foreground/50"> / {fmtNum(totalCreators)}</span>
      </span>
      {critical > 0 && (
        <span className="shrink-0">
          {t('managerV2.cockpit.crit', 'CRIT')}{' '}
          <span className="text-error font-semibold">{fmtNum(critical)}</span>
        </span>
      )}
      <span className="shrink-0 text-muted-foreground/40">{version || '·'}</span>
    </div>
  );
}
